var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.9992C0.75 15.9117 3.9 20.0742 8.25 21.6117V0.386719C3.9 1.92422 0.75 6.08672 0.75 10.9992ZM23.25 10.9992C23.25 6.08672 20.1375 1.92422 15.75 0.386719V21.6117C20.1375 20.0742 23.25 15.9117 23.25 10.9992Z",
    fill: "#83BF4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.acb5bd4c1f1cdac5e4e769965defbbe6.svg";
export { ForwardRef as ReactComponent };